// App Badging API helper.
// Sets a number badge on the installed PWA app icon (home screen / dock / taskbar).
// Supported on:
// - Chrome/Edge desktop (installed PWA)
// - Android Chrome (installed PWA)
// - iOS 16.4+ Safari (when installed to Home Screen)
// Silently no-ops on unsupported browsers.

type BadgeNavigator = Navigator & {
  setAppBadge?: (count?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
};

export function setAppBadge(count: number): void {
  if (typeof navigator === "undefined") return;
  const nav = navigator as BadgeNavigator;
  try {
    if (count > 0 && typeof nav.setAppBadge === "function") {
      nav.setAppBadge(count).catch(() => undefined);
    } else if (typeof nav.clearAppBadge === "function") {
      nav.clearAppBadge().catch(() => undefined);
    }
  } catch {
    // Ignore — badging is a progressive enhancement.
  }
}

export function clearAppBadge(): void {
  if (typeof navigator === "undefined") return;
  const nav = navigator as BadgeNavigator;
  try {
    nav.clearAppBadge?.().catch(() => undefined);
  } catch {
    // Ignore.
  }
}
